import CreatorSetupPage from './CreatorSetupPage'

export default CreatorSetupPage
